var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNbStar(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 142.1 142.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M104.1,97.3c-1.9-1.9-2.8-4.5-2.8-7.2V70.8V51.6c0.1-2.7,1-5.3,2.8-7.3l36.3-36c1.9-1.9,1.9-5,0-6.8h0l0,0 c-1.9-1.9-5-1.9-6.8,0l-36.3,36c-1.9,1.9-4.6,3.3-7.2,3.3H70.8H51.8c-2.7,0-5.6-1.5-7.6-3.3l-36-36c-1.9-1.9-4.9-1.9-6.8,0l0,0 l0,0c-1.9,1.9-1.9,5,0,6.8l36,36c1.9,1.9,2.9,4.5,2.9,7.2l0,19.3l0,19.3c0,2.7-1.1,5.2-2.9,7.2l-36,36.6c-1.9,1.9-1.9,4.9,0,6.8 l0,0l0,0c1.9,1.9,5,1.9,6.8,0l36-36.6c1.9-1.8,4.5-2.5,7.2-2.5h19.2h19.4c2.7,0,5.5,1.1,7.4,2.9l35.9,36.2c1.9,1.9,4.9,1.9,6.8,0 l0,0h0c1.9-1.9,1.9-5,0-6.8L104.1,97.3z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNbStar);
export default __webpack_public_path__ + "static/media/nb-star.6a0970d6bb49bff76b1f677fe3e839c8.svg";
export { ForwardRef as ReactComponent };